import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class ProjectPreorderAttachmentAPI {
    public static async upload(preorderId: string, file: Blob, documentType?: string | null, positionId?: string | null) {
        const formData = new FormData();
        formData.append('file', file);
        if (!positionId) {
            formData.append('project_preorder_id', preorderId);
        }
        if (documentType) {
            formData.append('document_type', documentType);
        }
        if (positionId) {
            formData.append('project_preorder_position_id', positionId);
        }
        let attachment;
        try {
            attachment = (await ApiController.post(ApiRoutes.projectPreorderAttachment.create, formData)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(attachment);
    }

    public static async copyToOrder(
        attachmentId: string,
        target: { technologistOrderId?: string; projectInternalOrderId?: string },
    ) {
        const formData = new FormData();
        if (target.technologistOrderId) {
            formData.append('technologist_order_id', target.technologistOrderId);
        }
        if (target.projectInternalOrderId) {
            formData.append('project_internal_order_id', target.projectInternalOrderId);
        }
        try {
            return (await ApiController.post(ApiRoutes.projectPreorderAttachment.copyToOrder(attachmentId), formData)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }
}